/* eslint-disable @typescript-eslint/no-explicit-any */
import requsetMarketPlace from 'utils/requestMatketPlace';

const systemProductService = {
  getList: (params: any) =>
    requsetMarketPlace.get('/system-product', { params }),
  getSystemProductExcel: (params: any) =>
    requsetMarketPlace.get('/client-product-excel', { params }),
  getListDiscounthistory: (params: any) =>
    requsetMarketPlace.get('/system-product-discount-history', { params }),
  getSystemProductById: (id: any) =>
    requsetMarketPlace.get(`/system-product/${id}`),
  createSystemProduct: (data: any) =>
    requsetMarketPlace.post('/system-product', data),
  createDiscountDeactivate: (data: any) =>
    requsetMarketPlace.post('/system-product-discount/deactivate', data),
  deleteSystemProduct: (id: any) =>
    requsetMarketPlace.delete(`/system-product/${id}`),
  updateSystemProduct: (data: any) =>
    requsetMarketPlace.put(`/system-product`, data)
};

export default systemProductService;
